import React, {useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import GameCard from '../components/GameCard';
import DashboardSlider from '../components/DashboardSlider';
import BackButton from '../components/BackButton';
export default function SingleCategory() {
    const { state } = useLocation();
    const category = state?.category;

    const [selectedGame, setSelectedGame] = useState([])


    const handleGameSelect = (game) => {
        setSelectedGame(game)
         window.scrollTo(0, 0);
    };

    useEffect(() => {
        if (window.AOS) {
          window.AOS.init({ duration: 500 });
        }
      }, []);
      
    useEffect(() => {
        window.scroll(0, 0);
    }, [])

    if (!category) {
        return (
            <div>
                <Sidebar />
                
                <div className="main-body">
                    <BackButton/>
                    <h3>No category data found.</h3>
                </div>
            </div>
        );
    }




    return (
        <div>
            <Sidebar />
            <div className="main-body">
            <BackButton/>
                <div className='d-flex flex-row align-items-center gap-2 my-3' >
                    <img src={category?.Icon} />
                    <div>

                        <h4 className='m-0' ><strong>{category.Name}</strong></h4>
                        <p className='m-0'>Total Games : {category.Content.length}</p>
                    </div>
                </div>


                <div>
                    {selectedGame?.Title && <DashboardSlider game={selectedGame} />}
                </div>



                <div className='games_grid mt-3' >
                    {category.Content.map((game, index) => (
                        <GameCard key={index} game={game} onInfoClick={handleGameSelect} />
                    ))}
                </div>
            </div>
        </div>
    );
}
